"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useStyles = void 0;
var react_1 = __importStar(require("react"));
var clsx_1 = __importDefault(require("clsx"));
var styles_1 = require("@material-ui/core/styles");
var ListItem_1 = __importDefault(require("@material-ui/core/ListItem"));
var ListItemText_1 = __importDefault(require("@material-ui/core/ListItemText"));
var EditRounded_1 = __importDefault(require("@material-ui/icons/EditRounded"));
var IconButton_1 = __importDefault(require("../../IconButton"));
exports.useStyles = styles_1.makeStyles(function (theme) { return ({
    root: {
        position: 'relative',
    },
    focused: {
        backgroundColor: theme.palette.action.selected,
    },
    progress: {
        width: 40,
    },
    editButtonWrapper: {
        display: 'flex',
        position: 'absolute',
        backgroundColor: 'transparent',
        top: 0,
        right: 0,
        bottom: 0,
        alignItems: 'center',
        background: "linear-gradient(90deg, rgba(255, 255, 255, 0) 0%, " + theme.palette.grey[400] + " 100%)",
        padding: theme.spacing(0, 1, 0, 3),
    },
}); });
var SelectOption = function (_a) {
    var _b;
    var classNameProp = _a.className, children = _a.children, innerProps = _a.innerProps, isFocused = _a.isFocused, selectProps = _a.selectProps, data = _a.data;
    var classes = exports.useStyles();
    var handleClickEdit = react_1.useCallback(function (event) {
        event.preventDefault();
        event.stopPropagation();
        if (selectProps.onClickEditOption) {
            selectProps.onClickEditOption(data);
        }
    }, [data, selectProps]);
    return (react_1.default.createElement(ListItem_1.default, __assign({ button: true, className: clsx_1.default(classes.root, (_b = {}, _b[classes.focused] = isFocused, _b), classNameProp) }, innerProps),
        react_1.default.createElement(ListItemText_1.default, null, children),
        selectProps.editable && isFocused && (react_1.default.createElement("div", { className: classes.editButtonWrapper },
            react_1.default.createElement(IconButton_1.default, { size: "small", "aria-label": "Edit", color: "primary", onClick: handleClickEdit },
                react_1.default.createElement(EditRounded_1.default, null))))));
};
exports.default = SelectOption;
//# sourceMappingURL=SelectOption.js.map